import { useModal } from "../contexts";
import Modal from './Modal';
import useUser from '../hooks/useUser';
import { useTranslation } from 'react-i18next';

interface Props {
  oauthUrl: string;
  onClose?: () => void;
}

function OAuthModalXero(props: Props) {
  const { t } = useTranslation();
  const { closeModal } = useModal();
  const { refreshUser } = useUser();

  function handleInstallIntegration() {
    window.open(props.oauthUrl, "_blank");
    window.addEventListener("focus", getCurrentUserOnFocus);
  }

  async function getCurrentUserOnFocus() {
    window.removeEventListener("focus", getCurrentUserOnFocus);

    refreshUser();
    closeModal(props.onClose);
  }

  return (
    <Modal
      size="sm"
      title={t("Authorise Xero with Portant")}
      subtitle={t("Portant requires access to invoice data within your Xero account.")}
      primaryButtonProps={{ text: t("Authorise Xero with Portant"), onClick: handleInstallIntegration }}
    />
  );
}

export default OAuthModalXero;
